import { Card, Col, Container, Row, Form, Button, Modal } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import '../candidateRightContentPane/candidateLanguageProficiencyPanel.css';
import ProficiencyProgressBar from '../../clients/candidate-information/client-right-content-panes/proficiencyProgressBar';
import { faEdit, faPen, faPlus, faPlusCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CandidatePostLoginService } from '../../../services/candidatePostLoginService';
import { MasterDataService } from '../../../services/masterDataService';
import CloseIcon from '../../../assets/images/Ic_close.png';
const PROFICIENCY_OPTIONS = [
  { label: 'Reading', value: 'READING_PROFICIENCY' },
  { label: 'Writing', value: 'WRITING_PROFICIENCY' },
  { label: 'Speaking', value: 'SPEAKING_PROFICIENCY' },
  { label: 'Full', value: 'FULL_PROFICIENCY' },
];
const emptyLanguage = { language: '', proficiency: '' };

const CandidateLanguageProficiencyPanel = ({ languageProficiency }) => {
  const safeInitialData = Array.isArray(languageProficiency) ? languageProficiency : [];

  const [languages, setLanguages] = useState(safeInitialData);
  const [modalLanguages, setModalLanguages] = useState(
    safeInitialData.map(item => ({ ...item }))
  );
  const [showModal, setShowModal] = useState(false);
  const [allLanguages, setAllLanguages] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  // ✅ Sync with prop changes (if parent reloads data later)
  useEffect(() => {
    const normalized = Array.isArray(languageProficiency) ? languageProficiency : [];
    setLanguages(normalized);
    setModalLanguages(normalized.map(item => ({ ...item })));
  }, [languageProficiency]);

  useEffect(() => {
    MasterDataService.getAllLanguages().then((res) => {
      setAllLanguages(res.data);
    });
  }, []);


  const handleModalChange = (index, field, value) => {
    setModalLanguages((prev) => {
      const updated = prev.map((item, idx) => idx === index ? { ...item, [field]: value } : item);
      return updated;
    });
  };


  const handleModalAdd = () => {
    setModalLanguages((prev) => [...prev, { ...emptyLanguage }]);
  };



  const handleModalSave = async () => {
    const hasEmptyLanguage = modalLanguages.some(lang => !lang.language || lang.language.trim() === '');

    if (hasEmptyLanguage) {
      setErrorMessage('Language is a required field. Please select a language for all entries.');
      return;
    }
    try {
      setLoading(true);
      const payload = {
        languageProficiencies: modalLanguages.map(lang => ({
          language: lang.language,
          proficiency: lang.proficiency
        }))
      };

      // await CandidatePostLoginService.submitLanguageProficiency(payload);
      await CandidatePostLoginService.submitPanelByType('LANGUAGE_PROFICIENCY', payload);

      setLanguages(modalLanguages);
      setShowModal(false);
    } catch (error) {
      console.error("Failed to update language proficiency", error);
      alert("Error updating language proficiency. Please try again.");
    }
    finally {
      setLoading(false);
    }
  };

  const handleRemoveLanguage = (indexToRemove) => {
    setModalLanguages((prev) => prev.filter((_, index) => index !== indexToRemove));
  };


  return (
    <Card className="languageProfPanel mt-2">
      {errorMessage && (
        <div className="custom-alert-overlay">
          <div className="custom-alert-box">
            <div className="custom-alert-content">
              <p>{errorMessage}</p>
              <button className="custom-alert-button" onClick={() => setErrorMessage('')}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      <Card.Body>
        <Container>
          <Row className="align-items-center">
            <Col>
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h3 className="mb-0" style={{ whiteSpace: 'nowrap' }}>Language Proficiency</h3>
                <FontAwesomeIcon
                  icon={faPen}
                  // className="me-1"
                  size="sm"
                  style={{ color: '#F35824', cursor: 'pointer' }}
                  onClick={() => setShowModal(true)}
                />
              </div>
            </Col>
          </Row>

          {languages.map((lang, index) => (
            <Row key={index} className="language-row mt-2">
              <Col>
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <span className="language-name" style={{ minWidth: '120px', whiteSpace: 'nowrap' }}>
                    {lang.language}
                  </span>
                  {lang.proficiency && (
                    <div style={{ flexGrow: 1 }}>
                      <ProficiencyProgressBar proficiency={lang.proficiency} />
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          ))}

        </Container>
      </Card.Body>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title>Edit Language Proficiency</Modal.Title>
          <img
            src={CloseIcon}
            alt="Close"
            onClick={() => setShowModal(false)}
            style={{
              cursor: 'pointer',
              width: '24px',
              height: '24px',
            }}
          />
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row className="fw-bold mb-2">
              <Col md={4}>Language <span style={{ color: 'red' }}>*</span></Col>
              <Col md={5}>Proficiency</Col>
              <Col md={3}></Col>
            </Row>
            {modalLanguages.map((lang, index) => (
              <Row className="language-row mt-2 align-items-center" key={index}>
                <Col md={4}>
                  <Form.Select
                    style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                    value={lang.language}
                    onChange={(e) => handleModalChange(index, 'language', e.target.value)}
                  >
                    <option value="">--Select--</option>
                    {allLanguages.map((language, idx) => (
                      <option key={idx} value={language}>{language}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md={5}>
                  <Form.Select
                    style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                    value={lang.proficiency}
                    onChange={(e) => handleModalChange(index, 'proficiency', e.target.value)}
                  >
                    <option value="">--Select--</option>
                    {PROFICIENCY_OPTIONS.map((opt) => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </Form.Select>

                </Col>
                <Col md={3} className="text-end">
                  <div
                    size="sm"
                    onClick={() => handleRemoveLanguage(index)}
                    style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                  >
                    <FontAwesomeIcon icon={faMinusCircle} />
                  </div>
                </Col>
              </Row>

            ))}

            <Row className="mt-3">
              <Col>
                <div
                  onClick={handleModalAdd}
                  style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                >
                  <FontAwesomeIcon icon={faPlusCircle} /> Add Language
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={() => setShowModal(false)} className="candidate-profile-edit-cancel">Cancel</button>
          <button
            onClick={handleModalSave}
            className="candidate-profile-edit-save"
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save'}
          </button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

export default CandidateLanguageProficiencyPanel;
